"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CustomerClaimsImpl_defaulted, _CustomerClaimsImpl_ec, _CustomerBuilder_claims;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerBuilder = exports.CustomerClaimNames = exports.customerClaimNames = void 0;
exports.FromCustomerWireClaims = FromCustomerWireClaims;
exports.TestCustomerClaims = TestCustomerClaims;
const claims_1 = require("./claims");
class customerClaimNames {
    constructor() {
        this.CUSTOMER_ID = 'custom:customerId';
        this.TENANT = 'custom:tenant';
    }
}
exports.customerClaimNames = customerClaimNames;
exports.CustomerClaimNames = new customerClaimNames();
function ToCustomerWireClaims(claims) {
    const ret = {};
    if ((0, claims_1.isSome)(claims.customerId)) {
        ret[exports.CustomerClaimNames.CUSTOMER_ID] = (0, claims_1.toString)(claims.customerId);
    }
    if ((0, claims_1.isSome)(claims.tenant)) {
        ret[exports.CustomerClaimNames.TENANT] = (0, claims_1.toString)(claims.tenant);
    }
    return ret;
}
function toEntity(x) {
    return {
        customerId: claims_1.WithDefault.from(x.customerId, ''),
        tenant: claims_1.WithDefault.from(x.tenant, ''),
    };
}
function FromCustomerWireClaims(claims, defaults = {}) {
    const withDefaults = {
        ...ToCustomerWireClaims(toEntity(defaults)),
        ...claims,
    };
    const ec = new claims_1.ErrorCollector('customer');
    return new CustomerClaimsImpl(ec, {
        customerId: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CustomerClaimNames.CUSTOMER_ID, '', ec),
        tenant: (0, claims_1.requiredStringAttribute)(withDefaults, exports.CustomerClaimNames.TENANT, '', ec),
    });
}
class CustomerClaimsImpl {
    constructor(ec, params) {
        _CustomerClaimsImpl_defaulted.set(this, void 0);
        _CustomerClaimsImpl_ec.set(this, void 0);
        this.customerId = () => {
            return __classPrivateFieldGet(this, _CustomerClaimsImpl_defaulted, "f").customerId.val;
        };
        this.tenant = () => {
            return __classPrivateFieldGet(this, _CustomerClaimsImpl_defaulted, "f").tenant.val;
        };
        __classPrivateFieldSet(this, _CustomerClaimsImpl_defaulted, params, "f");
        __classPrivateFieldSet(this, _CustomerClaimsImpl_ec, ec, "f");
    }
    wireCustomerId() {
        return __classPrivateFieldGet(this, _CustomerClaimsImpl_defaulted, "f").customerId.val;
    }
    wireTenant() {
        return __classPrivateFieldGet(this, _CustomerClaimsImpl_defaulted, "f").tenant.val;
    }
    errors() {
        return __classPrivateFieldGet(this, _CustomerClaimsImpl_ec, "f").errors;
    }
    isError() {
        return __classPrivateFieldGet(this, _CustomerClaimsImpl_ec, "f").isError();
    }
    lastError() {
        return __classPrivateFieldGet(this, _CustomerClaimsImpl_ec, "f").lastError();
    }
    toJSON() {
        return ToCustomerWireClaims(__classPrivateFieldGet(this, _CustomerClaimsImpl_defaulted, "f"));
    }
    toParams() {
        const ret = {};
        if ((0, claims_1.isSome)(__classPrivateFieldGet(this, _CustomerClaimsImpl_defaulted, "f").customerId)) {
            ret.customerId = __classPrivateFieldGet(this, _CustomerClaimsImpl_defaulted, "f").customerId.val;
        }
        if ((0, claims_1.isSome)(__classPrivateFieldGet(this, _CustomerClaimsImpl_defaulted, "f").tenant)) {
            ret.tenant = __classPrivateFieldGet(this, _CustomerClaimsImpl_defaulted, "f").tenant.val;
        }
        return ret;
    }
}
_CustomerClaimsImpl_defaulted = new WeakMap(), _CustomerClaimsImpl_ec = new WeakMap();
function TestCustomerClaims() {
    return {
        customerId: 'default-customer-id',
        tenant: 'default-tenant',
    };
}
class CustomerBuilder {
    constructor(claims) {
        _CustomerBuilder_claims.set(this, void 0);
        __classPrivateFieldSet(this, _CustomerBuilder_claims, claims, "f");
    }
    build() {
        return FromCustomerWireClaims({}, __classPrivateFieldGet(this, _CustomerBuilder_claims, "f"));
    }
    customerId(customerId) {
        __classPrivateFieldGet(this, _CustomerBuilder_claims, "f").customerId = customerId;
        return this;
    }
    tenant(tenant) {
        __classPrivateFieldGet(this, _CustomerBuilder_claims, "f").tenant = tenant;
        return this;
    }
}
exports.CustomerBuilder = CustomerBuilder;
_CustomerBuilder_claims = new WeakMap();
//# sourceMappingURL=customer-claims.js.map